export default (function () {
  return {
    icon: {
      regular: '24px',
      small: '18px'
    }
  };
});